export { ChakraTextArea as default } from './ChakraTextArea'
export type { ChakraTextAreaProps } from './ChakraTextArea'
